<div tabindex="0" class="clickable-section" (click)="onProductClick()" (keydown)="onProductClick($event)">
  <img [src]="selectedColorWithImages.images[0]" [style.height.px]="imgHeight" class="with-backup" />
  <div class="title-wrapper">
    <span class="title">{{ title | titlecase }}</span>
    <i *ngIf="showTrash" class="fas fa-trash-alt" (click)="onTrashClick($event)"></i>
    <i *ngIf="showHeart && !isFavorite" class="far fa-heart" (click)="onHeartClick($event)"></i>
    <i *ngIf="showHeart && isFavorite" class="fas fa-heart" (click)="onHeartClick($event)"></i>
  </div>
</div>

<app-price [price]="price" [previousPrice]="previousPrice"></app-price>

<div *ngIf="shouldShowColors()" class="colors-wrapper">
  <app-color
    *ngFor="let colorWithImages of colorsWithImages"
    [name]="colorWithImages.color.name"
    [hexCode]="colorWithImages.color.hexCode"
    [isSelected]="isSelectedColor(colorWithImages)"
    (colorSelected)="onColorSelect(colorWithImages)"
  ></app-color>
</div>

<span *ngIf="previousPrice" class="discount">- {{ getDiscount() }}%</span>
